import type { ReactNode } from 'react'
import { Card, CardAction, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card'
import styles from './Panel.module.css'

export type PanelProps = {
  title: string

  subtitle?: ReactNode
  actions?: ReactNode
  children?: ReactNode
  id?: string

  level?: 1 | 2
}

export function Panel({ title, subtitle, actions, children, id, level = 2 }: PanelProps) {
  const heading =
    level === 1 ? (
      <h1 className={`${styles.title} ${styles.page}`}>{title}</h1>
    ) : (
      <h2 className={styles.title}>{title}</h2>
    )

  return (
    <Card id={id}>
      <CardHeader>
        <CardTitle>{heading}</CardTitle>
        {subtitle ? <CardDescription>{subtitle}</CardDescription> : null}

        {actions ? (
          <CardAction>
            <div className={styles.actions}>{actions}</div>
          </CardAction>
        ) : null}
      </CardHeader>
      {children ? <CardContent>{children}</CardContent> : null}
    </Card>
  )
}

export function Stack({ children }: { children: ReactNode }) {
  return <div className={styles.stack}>{children}</div>
}
